import { render, staticRenderFns } from "./addition_deductions_input.vue?vue&type=template&id=7f0c81ef&scoped=true"
import script from "./addition_deductions_input.vue?vue&type=script&lang=js"
export * from "./addition_deductions_input.vue?vue&type=script&lang=js"
import style0 from "./addition_deductions_input.vue?vue&type=style&index=0&id=7f0c81ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c81ef",
  null
  
)

export default component.exports